import { Api } from "api";
import { LevelType } from "types/dict";

export const getLevels = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget_levels/?hash_pw=${hash}`);
  return res.data;
};

export const getLevelRoots = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget_levels/utils/list_roots/?hash_pw=${hash}`);
  return res.data;
};

export const getLevelTreeStructure = async (budgetTypeId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget_levels/utils/get_tree_structure/${budgetTypeId}/?hash_pw=${hash}`);
  return res.data;
};

export const updateLevelTreeStructure = async (budgetTypeId: number, payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.patch(`/budget_levels/utils/rebuild_tree_structure/${budgetTypeId}/?hash_pw=${hash}`, payload);
  return res.data;
};

export const addLevel = async (budgetType: string, lvlCount: number, forecast: number, payload: any[]) => {
  const hash = localStorage.getItem("hash");
  const url = `/budget_levels/?hash_pw=${hash}&budget_type=${budgetType}&max_levels=${lvlCount}&forecast_min_level=${forecast}`;
  const res = await Api.post(url, payload);
  return res.data;
};

export const updateLevel = async (level: LevelType, new_status?: boolean) => {
  const hash = localStorage.getItem("hash");
  const id = `&budget_type_id=${level.budget_type_id}`;
  const name = `&new_budget_type=${level.budget_type}`;
  const number = `&level_number=${level.level_number}`;
  const status = `&status=${level.status}`;
  const posX = level.position ? `&position_x=${level.position.x}` : "";
  const posY = level.position ? `&position_y=${level.position.y}` : "";
  const url = `/budget_levels/?hash_pw=${hash}${id}${name}${number}${status}${posX}${posY}`;
  const res = await Api.put(url);
  return res.data;
};

export const addSublevel = async (level: LevelType, parentId: number) => {
  const hash = localStorage.getItem("hash");
  const name = `&budget_type=${level.budget_type}`;
  const number = `&level_number=${level.level_number}`;
  const url = `/budget_levels/${parentId}?hash_pw=${hash}${name}${number}`;
  const res = await Api.post(url);
  return res.data;
};
